import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-order_icon_fold_up",
  "use": "icon-order_icon_fold_up-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-order_icon_fold_up\"><g fill-rule=\"evenodd\"><circle cx=\"8\" cy=\"8\" r=\"8\" /><path d=\"M11.576 9.891c.218.17.536.137.712-.074a.48.48 0 0 0-.077-.69L8.347 6.11a.519.519 0 0 0-.632-.003L3.79 9.126a.48.48 0 0 0-.081.688.517.517 0 0 0 .711.08l3.606-2.775 3.55 2.772Z\" fill=\"#FFF\" fill-rule=\"nonzero\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol